import { Request } from '../../Servidor/Request';

export class SpeciesRequest {
    private sgepdengueespecie: number;
    private nome: string; 

    constructor(sgepdengueespecie: number, nome: string) {
        this.sgepdengueespecie = sgepdengueespecie;
        this.nome = nome;
    }


    /**
     * Getter sgepdengueespecie
     * @return {number}
     */
    public getSgepdengueespecie(): number {
        return this.sgepdengueespecie;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
   
}

export class SpeciesStructRequest {
    private sgepdengueespecie: number;

    constructor(sgepdengueespecie: number) {
        this.sgepdengueespecie = sgepdengueespecie;
    }


    /**
     * Getter sgepdengueespecie
     * @return {number}
     */
    public getSgepdengueespecie(): number {
        return this.sgepdengueespecie;
    }

}

export class SpeciesStructResponse {
    private sgepdengueespecie: number;
    private nome: string;

    constructor(sgepdengueespecie: number, nome: string) {
        this.sgepdengueespecie = sgepdengueespecie;
        this.nome = nome;
    }


    /**
     * Getter sgepdengueespecie
     * @return {number}
     */
    public getSgepdengueespecie(): number {
        return this.sgepdengueespecie;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class SpeciesInteractor {
    public fetchSave(request: SpeciesRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/especies/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: SpeciesStructRequest): PromiseLike<SpeciesStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/especies/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}